"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _default;
    }
});
const _dayjs = /*#__PURE__*/ _interop_require_default(require("dayjs"));
const _nocodbsdk = require("nocodb-sdk");
const _commonFns = /*#__PURE__*/ _interop_require_wildcard(require("./commonFns"));
const _convertUnits = require("~/helpers/convertUnits");
const _formulaFnHelper = require("~/helpers/formulaFnHelper");
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interop_require_wildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
        return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
        return {
            default: obj
        };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
        return cache.get(obj);
    }
    var newObj = {
        __proto__: null
    };
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj){
        if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) {
                Object.defineProperty(newObj, key, desc);
            } else {
                newObj[key] = obj[key];
            }
        }
    }
    newObj.default = obj;
    if (cache) {
        cache.set(obj, newObj);
    }
    return newObj;
}
const sqlite3 = _extends({}, _commonFns.default, {
    LEN: 'LENGTH',
    async CEILING (args) {
        return {
            builder: args.knex.raw(`round(${(await args.fn(args.pt.arguments[0])).builder} + 0.5)`)
        };
    },
    async FLOOR (args) {
        return {
            builder: args.knex.raw(`round(${(await args.fn(args.pt.arguments[0])).builder} - 0.5)`)
        };
    },
    MOD: async (args)=>{
        return args.fn({
            type: 'BinaryExpression',
            operator: '%',
            left: args.pt.arguments[0],
            right: args.pt.arguments[1]
        });
    },
    async REPEAT (args) {
        return {
            builder: args.knex.raw(`replace(printf('%.' || ${(await args.fn(args.pt.arguments[1])).builder} || 'c', '/'),'/',${(await args.fn(args.pt.arguments[0])).builder})`)
        };
    },
    NOW: (args)=>{
        return {
            builder: args.knex.raw(`DATETIME('now', 'localtime')`)
        };
    },
    SEARCH: 'INSTR',
    async INT (args) {
        return {
            builder: args.knex.raw(`CAST(${(await args.fn(args.pt.arguments[0])).builder} as INTEGER)`)
        };
    },
    LEFT: async (args)=>{
        const source = (await args.fn(args.pt.arguments[0])).builder;
        const length = (await args.fn(args.pt.arguments[1])).builder;
        return {
            builder: args.knex.raw(`SUBSTR(?,1,?)`, [
                source,
                length
            ])
        };
    },
    RIGHT: async (args)=>{
        const source = (await args.fn(args.pt.arguments[0])).builder;
        const length = (await args.fn(args.pt.arguments[1])).builder;
        return {
            builder: args.knex.raw(`SUBSTR(?,-(?))`, [
                source,
                length
            ])
        };
    },
    MID: 'SUBSTR',
    FLOAT: async (args)=>{
        return {
            builder: args.knex.raw(`CAST(${(await args.fn(args.pt.arguments[0])).builder} as FLOAT)`).wrap('(', ')')
        };
    },
    DATEADD: async ({ fn, knex, pt })=>{
        const source = (await fn(pt.arguments[0])).builder;
        let dateIN = (await fn(pt.arguments[1])).builder;
        if (typeof dateIN === 'object' && dateIN.toQuery) {
            dateIN = Number(dateIN.toQuery());
        }
        if (pt.arguments[2].type === 'Literal') {
            let dateModifier = (await fn(pt.arguments[2])).builder;
            if (typeof dateModifier === 'object' && dateModifier.toQuery) {
                dateModifier = dateModifier.toQuery();
            }
            const unit = (0, _commonFns.validateDateAddUnit)(String(dateModifier));
            const fullModifierRaw = `${dateIN > 0 ? '+' : ''}${dateIN} ${unit}`;
            return {
                builder: knex.raw(`CASE
        WHEN :source LIKE '%:%' THEN
          STRFTIME('%Y-%m-%dT%H:%M:%fZ', DATETIME(:source, 'utc', ':fullModifier'))
        ELSE
          DATE(:source, ':fullModifier')
        END`, {
                    source,
                    fullModifier: knex.raw(fullModifierRaw)
                })
            };
        }
        // Dynamic unit (field reference) — build modifier as a SQL expression
        // with proper ? bindings so knex nests the Raw correctly
        const unitBuilder = (await fn(pt.arguments[2])).builder;
        const safeUnit = (0, _commonFns.safeDateAddUnitSQL)(knex, unitBuilder);
        const prefix = `${dateIN > 0 ? '+' : ''}${dateIN} `;
        const fullModifier = knex.raw(`'${prefix}' || ?`, [
            safeUnit
        ]);
        return {
            builder: knex.raw(`CASE
      WHEN ? LIKE '%:%' THEN
        STRFTIME('%Y-%m-%dT%H:%M:%fZ', DATETIME(?, 'utc', ?))
      ELSE
        DATE(?, ?)
      END`, [
                source,
                source,
                fullModifier,
                source,
                fullModifier
            ])
        };
    },
    DATETIME_DIFF: async ({ fn, knex, pt })=>{
        var _datetime_expr1_bindings, _datetime_expr2_bindings;
        let datetime_expr1 = (await fn(pt.arguments[0])).builder;
        let datetime_expr2 = (await fn(pt.arguments[1])).builder;
        // JULIANDAY takes YYYY-MM-DD
        if (datetime_expr1.sql === '?' && ((_datetime_expr1_bindings = datetime_expr1.bindings) == null ? void 0 : _datetime_expr1_bindings[0])) {
            datetime_expr1 = `'${(0, _nocodbsdk.convertToTargetFormat)(datetime_expr1.bindings[0], (0, _nocodbsdk.getDateFormat)(datetime_expr1.bindings[0]), 'YYYY-MM-DD')}'`;
        }
        if (datetime_expr2.sql === '?' && ((_datetime_expr2_bindings = datetime_expr2.bindings) == null ? void 0 : _datetime_expr2_bindings[0])) {
            datetime_expr2 = `'${(0, _nocodbsdk.convertToTargetFormat)(datetime_expr2.bindings[0], (0, _nocodbsdk.getDateFormat)(datetime_expr2.bindings[0]), 'YYYY-MM-DD')}'`;
        }
        const rawUnit = pt.arguments[2] ? (await fn(pt.arguments[2])).builder.bindings[0] : 'seconds';
        let sql;
        const unit = (0, _convertUnits.convertUnits)(rawUnit, 'sqlite');
        switch(unit){
            case 'seconds':
                sql = `(strftime('%s', ${datetime_expr1}) - strftime('%s', ${datetime_expr2}))`;
                break;
            case 'minutes':
                sql = `(strftime('%s', ${datetime_expr1}) - strftime('%s', ${datetime_expr2})) / 60`;
                break;
            case 'hours':
                sql = `(strftime('%s', ${datetime_expr1}) - strftime('%s', ${datetime_expr2})) / 3600`;
                break;
            case 'milliseconds':
                sql = `(strftime('%s', ${datetime_expr1}) - strftime('%s', ${datetime_expr2})) * 1000`;
                break;
            case 'weeks':
                sql = `ROUND((JULIANDAY(${datetime_expr1}) - JULIANDAY(${datetime_expr2})) / 7)`;
                break;
            case 'months':
                sql = `(strftime('%Y', ${datetime_expr1}) - strftime('%Y', ${datetime_expr2})) * 12 + (strftime('%m', ${datetime_expr1}) - strftime('%m', ${datetime_expr2})) `;
                break;
            case 'quarters':
                sql = `(strftime('%Y', ${datetime_expr1}) - strftime('%Y', ${datetime_expr2})) * 4 + (strftime('%m', ${datetime_expr1}) - strftime('%m', ${datetime_expr2})) / 3`;
                break;
            case 'years':
                sql = `CASE
                WHEN (${datetime_expr2} < ${datetime_expr1}) THEN
                (
                  (strftime('%Y', ${datetime_expr1}) - strftime('%Y', ${datetime_expr2}))
                  - (strftime('%m', ${datetime_expr1}) < strftime('%m', ${datetime_expr2})
                  OR (strftime('%m', ${datetime_expr1}) = strftime('%m', ${datetime_expr2})
                  AND strftime('%d', ${datetime_expr1}) < strftime('%d', ${datetime_expr2})))
                )
                WHEN (${datetime_expr2} > ${datetime_expr1}) THEN
                -1 * (
                  (strftime('%Y', ${datetime_expr2}) - strftime('%Y', ${datetime_expr1}))
                  - (strftime('%m', ${datetime_expr2}) < strftime('%m', ${datetime_expr1})
                  OR (strftime('%m', ${datetime_expr2}) = strftime('%m', ${datetime_expr1})
                  AND strftime('%d', ${datetime_expr2}) < strftime('%d', ${datetime_expr1})))
                )
                ELSE 0
              END`;
                break;
            case 'days':
                sql = `JULIANDAY(${datetime_expr1}) - JULIANDAY(${datetime_expr2})`;
                break;
            default:
                sql = '';
        }
        return {
            builder: knex.raw(`ROUND(${sql})`)
        };
    },
    WEEKDAY: async ({ fn, knex, pt })=>{
        var _pt_arguments_;
        // strftime('%w', date) - day of week 0 - 6 with Sunday == 0
        // WEEKDAY() returns an index from 0 to 6 for Monday to Sunday
        return {
            builder: knex.raw(`(strftime('%w', ${pt.arguments[0].type === 'Literal' ? `'${(0, _dayjs.default)((await fn(pt.arguments[0])).builder).format('YYYY-MM-DD')}'` : (await fn(pt.arguments[0])).builder}) - 1 - ${(0, _formulaFnHelper.getWeekdayByText)(pt == null ? void 0 : (_pt_arguments_ = pt.arguments[1]) == null ? void 0 : _pt_arguments_.value)} % 7 + 7) % 7`)
        };
    },
    DAY: async ({ fn, knex, pt })=>{
        return {
            builder: knex.raw(`CAST(strftime('%d', (${(await fn(pt == null ? void 0 : pt.arguments[0])).builder})) AS INTEGER)`)
        };
    },
    MONTH: async ({ fn, knex, pt })=>{
        return {
            builder: knex.raw(`CAST(strftime('%m', (${(await fn(pt == null ? void 0 : pt.arguments[0])).builder})) AS INTEGER)`)
        };
    },
    YEAR: async ({ fn, knex, pt })=>{
        return {
            builder: knex.raw(`CAST(strftime('%Y', (${(await fn(pt == null ? void 0 : pt.arguments[0])).builder})) AS INTEGER)`)
        };
    },
    HOUR: async ({ fn, knex, pt })=>{
        return {
            builder: knex.raw(`CAST(strftime('%H', (${(await fn(pt == null ? void 0 : pt.arguments[0])).builder})) AS INTEGER)`)
        };
    },
    AND: async (args)=>{
        const predicates = args.pt.arguments.map(()=>'?').join(' AND ');
        const parsedArguments = await Promise.all(args.pt.arguments.map(async (ar)=>{
            const argsStr = (await args.fn(ar, '', 'AND')).builder;
            return {
                builder: argsStr
            };
        }));
        const clause = args.knex.raw(predicates, parsedArguments.map((a)=>a.builder)).wrap('(', ')');
        return {
            builder: args.knex.raw(`CASE WHEN ? THEN 1 ELSE 0 END `, [
                clause
            ])
        };
    },
    OR: async (args)=>{
        const predicates = args.pt.arguments.map(()=>'?').join(' OR ');
        const parsedArguments = await Promise.all(args.pt.arguments.map(async (ar)=>{
            const argsStr = (await args.fn(ar, '', 'OR')).builder;
            return {
                builder: argsStr
            };
        }));
        const clause = args.knex.raw(predicates, parsedArguments.map((a)=>a.builder)).wrap('(', ')');
        return {
            builder: args.knex.raw(`CASE WHEN ? THEN 1 ELSE 0 END `, [
                clause
            ])
        };
    },
    async JSON_EXTRACT (args) {
        const source = (await args.fn(args.pt.arguments[0])).builder;
        const needle = (await args.fn(args.pt.arguments[1])).builder;
        return {
            builder: args.knex.raw(`CASE WHEN json_valid(:source) = 1 THEN json_extract(:source, CONCAT('$', :needle)) ELSE NULL END`, {
                source,
                needle
            })
        };
    }
});
const _default = sqlite3;
